import { FilterGlobalUseCase } from '@/application/filter/filetrGlobalUseCase';

let _filterGlobalUseCase: FilterGlobalUseCase | null = null;

/**
 * Función que inyecta una instancia de FilterGlobalUseCase
 * Proporciona valores por defecto dinámicos para year y semester
 */
export const getFilterGlobalUseCase = (): FilterGlobalUseCase => {
  if (!_filterGlobalUseCase) {
    _filterGlobalUseCase = new FilterGlobalUseCase();
  }
  return _filterGlobalUseCase;
};

/**
 * Función para resetear la instancia
 */
export const resetFilterContainer = (): void => {
  _filterGlobalUseCase = null;
};
